export default function MySQL_LOG2() {
  return (
    <div>
      <h2>MySQL_LOG2</h2>    </div>
  );
}